export default {
    importContactReadAllBegin(state) {
        state.loading = true;
    },

    importContactReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data;
        state.initialData = state.data;
    },

    importReadBegin(state) {
        state.loading = true;
    },

    importReadSuccess(state, data) {
        state.loading = false;
        state.masterImport = data;
    },

    importReadErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    importContactRunBegin(state) {
        state.loading = true;
    },

    importContactRunSuccess(state, data) {
        state.loading = false;
        state.masterImport = data;
    },

    importContactRunErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    importReadAllBegin(state) {
        state.loading = true;
    },

    importReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list;
        state.total = data.total;
    },

    importReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    userReadAllBegin(state) {
        state.loadingUsers = true;
    },

    userReadAllSuccess(state, data) {
        state.loadingUsers = false;

        // format the data for select input
        state.users = data.list.map(user => {
            return {
                label: `${user.firstName} ${user.lastName}`,
                value: user.id
            };
        });

//        state.users = userList || [];
    },

    userReadAllErr(state, err) {
        state.loadingUsers = false;
        state.error = err;
    },

    importDetailReadAllBegin(state) {
        state.loading = true;
    },

    importDetailReadAllSuccess(state, data) {
        state.loading = false;
        state.detail = data.list;
        state.total = data.total;
    },

    importDetailReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },
};